<script>
  import { Link } from "yrv/build/dist";
  import { galleryData, galleryUrlData, nanoID, billboardNode } from "../Api/store";

  const container = document.getElementById($nanoID);
</script>

{#if $galleryData}
  <div class="grid grid-cols-3 gap-4" id={$nanoID}>
    {#each $galleryData.items as item, index}
      <Link
        on:click={() => {
          const offset = container.offsetTop - ($billboardNode ? $billboardNode.offsetHeight : 0) - 80;
          window.scrollTo(0, offset);
        }}
        href={`${$galleryUrlData}/bild/${index + 1}`}
        title="Öffne Bild {index + 1}"
        class="transition duration-500 hocus:scale-105 hocus:shadow-md"
      >
        <img class="pointer-events-none" loading="lazy" src={item?.thumbnailSrc || item?.imageSrc} alt="" />
      </Link>
    {/each}
  </div>
{/if}
